import KTBlockUI from 'assets/plugins/ktblockui';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import feHelper from 'features/FE/feHelper';
import { setData } from 'features/FE/feSlice';
import { FastField, Field, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSDropdown, {
  KTBSDropdowAutoCloseBehavior,
} from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTFolderTreeView from 'general/components/OtherKeenComponents/KTFolderTreeView';
import KTScrollCard, { KTScrollCardDirections } from 'general/components/OtherKeenComponents/KTScrollCard';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import StringUtils from 'general/utils/StringUtils';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _, { chain } from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

function ChargePointDetailScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const chargeConnectorSerial = router.query?.chargeConnectorSerial;
  const [vehicleBrandList, setVehicleBrandList] = useState();
  const [chargePointDetail, setChargePointDetail] = useState({});
  const [chargeConnectorDetail, setChargeConnectorDetail] = useState({});
  const [chargePricing, setChargePricing] = useState({});
  const [creatingLink, setCreatingLink] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredFolderTreeData, setFilteredFolderTreeData] = useState();
  const [selectedModel, setSelectedModel] = useState();
  const [currentBattery, setCurrentBattery] = useState();
  const [needAmount, setNeedAmount] = useState();
  const [paymentAmount, setPaymentAmount] = useState();
  const [isTouch, setIsTouch] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [openedBrands, setOpenedBrands] = useState([]);
  const [paymentMethodsList, setPaymentMethodsList] = useState([]);
  const refContainer = useRef();
  const refFormik = useRef();
  const refCardInfo = useRef();
  const [currentPrice, setCurrentPrice] = useState();
  const [showNote, setShowNote] = useState(false);
  const [chargeConnectorId, setChargeConnectorId] = useState(null);
  const flatChargeMode = useMemo(() => {
    return chargePricing?.pricingMode === ChargeConstants.ChargePricingMode.FLAT;
  }, [chargePricing])
  const [fundingSource, setFundingSource] = useState('');

  const handleComputeNeedAmount = (price) => {
    return (price * selectedModel?.model.batteryCapacity * (100 - currentBattery)) / 100;
  }
  useEffect(() => {
    if (!flatChargeMode) {
      const currentPrice = feHelper.getCurrentChargePrice(chargePricing);
      setCurrentPrice(currentPrice);
    } else {
      setCurrentPrice(chargePricing?.flatPrice);
    }
  }, [chargePricing]);

  const baseUrl = window.location.origin;

  useEffect(() => {
    const handleGetPaymentMethodList = async () => {
      const res = await miscHelper.callApiGetAppConfig();
      if (res) {
        const paymentConfig = res.config.find(item => item.key === "enablePaymentMethods_V2");
        const paymentMethods = JSON.parse(paymentConfig.value);
        setPaymentMethodsList(paymentMethods);
      }
    };

    handleGetPaymentMethodList();
  }, [])

  useEffect(() => {
    const handleGetBrandList = async () => {
      const res = await feHelper.callApiGetBrandList();
      if (res) {
        setVehicleBrandList(res);
      }
    };

    handleGetBrandList();
  }, []);

  const handleSubmit = async () => {
    const values = refFormik.current.values;
    refFormik.current?.handleSubmit();
    const invalidFeedback = document.getElementsByClassName('invalid-feedback')[0];
    if (values.amount === '') {
      setIsInvalid(true);
      invalidFeedback.innerText = t('amountRequired');
    } else if (values.amount < 1) {
      setIsInvalid(true);
      invalidFeedback.innerText = t('amountGreaterZero');
    }
    const errors = await refFormik.current.validateForm();
    if (Object.keys(errors)?.length === 0) {
      if (!Utils.isValid(fundingSource)) {
        ToastHelper.showError('Vui lòng chọn phương thức thanh toán');
        return;
      }

      const params = {
        connectorId: chargeConnectorId,
        prepaidAmount: values.amount,
        plate: values.plate,
        fundingSource: fundingSource,
        startingPercentage: values.batteryPercent,
        batteryCapacity: selectedModel?.model?.batteryCapacity,
        redirectUrl: fundingSource === 'VNPAY' ? `${baseUrl}/prepaid/qr/transaction/` : ''
      };
      handlePayment(params);
    }
  };

  useEffect(() => {
    const handleGetChargeConnectorDetail = async () => {
      try {
        const res = await feHelper.callApiGetChargeConnectorDetail(chargeConnectorSerial);
        if (res) {
          setChargeConnectorDetail({ ...chargeConnectorDetail, ...(res.connector ?? {}) });
          setChargePricing(res.pricing ?? {});
          setChargeConnectorId(res.connector?.connectorId);
        }
      } catch (error) {
        ToastHelper.showError(error.response.data.reason);
      }
    };

    handleGetChargeConnectorDetail();
  }, [chargeConnectorSerial]);
  useEffect(() => {
    setChargePointDetail(chargeConnectorDetail?.chargePoint ?? {});
  }, [chargeConnectorDetail]);
  useEffect(() => {
    const target = document.querySelector('#container-content');
    if (target && !refContainer.current) {
      const blockUI = new KTBlockUI(target);
      refContainer.current = blockUI;
    }
  }, []);

  useEffect(() => {
    const filterVehicleBrandList = vehicleBrandList
      ?.map((brand) => {
        const filterModelList = brand.models.filter((model) =>
          StringUtils.removeVietnameseTones(model.name)
            .toLowerCase()
            .includes(StringUtils.removeVietnameseTones(searchTerm).toLowerCase())
        );
        return {
          ...brand,
          models: filterModelList,
        };
      })
      .filter(
        (brand) =>
          StringUtils.removeVietnameseTones(brand.name)
            .toLowerCase()
            .includes(StringUtils.removeVietnameseTones(searchTerm).toLowerCase()) ||
          brand.models.length > 0
      );

    const folderTreeData = filterVehicleBrandList?.map((brand) => ({
      type: 'brand',
      name: brand.name,
      id: brand.brandId,
      image: brand.logo,
      children: brand.models.map((model) => ({
        type: 'model',
        name: model.name,
        id: model.modelId,
        image: model.image,
      })),
    }));

    setFilteredFolderTreeData(folderTreeData);

    if (searchTerm?.length > 0) {
      const brandsToOpen = filterVehicleBrandList
        ?.filter((brand) => brand.models.length > 0)
        ?.map((brand) => brand.brandId);

      setOpenedBrands(brandsToOpen);
    } else {
      setOpenedBrands([]);
    }
  }, [searchTerm, vehicleBrandList]);

  useEffect(() => {
    if (!selectedModel || !currentBattery) return;

    if (flatChargeMode) {
      const amount = handleComputeNeedAmount(chargePricing?.flatPrice);
      setNeedAmount(amount);
      refFormik.current.setFieldValue('amount', Math.round(amount).toString());
      setIsInvalid(false);
      setPaymentAmount(amount);
    } else {
      setShowNote(true);
    }
  }, [currentBattery, selectedModel]);

  useEffect(() => {
    const invalidFeedback = document.getElementsByClassName('invalid-feedback')[0];
    if (invalidFeedback) {
      if (paymentAmount === undefined || paymentAmount === '') {
        invalidFeedback.innerText = 'Số tiền cần sạc không được để trống';
      } else if (paymentAmount < 1) {
        invalidFeedback.innerText = t('amountGreaterZero');
      } else {
        invalidFeedback.innerText = '';
      }
    }
  }, [paymentAmount]);

  // ---- methods ----
  const buildRowItem = (name, value, valueColor = AppColors.gray[800]) => {
    return (
      <div className="d-flex justify-content-between px-4">
        <span
          style={{
            color: AppColors.gray[600],
            fontWeight: '500',
            fontSize: Utils.convertToFontSize(16),
          }}
        >
          {name}
        </span>
        <span
          style={{
            color: valueColor,
            fontWeight: '600',
            fontSize: Utils.convertToFontSize(16),
          }}
        >
          {value}
        </span>
      </div>
    );
  };

  const handlePayment = async (params) => {
    // exit();
    setCreatingLink(true);
    if (refContainer.current) {
      refContainer.current.block();
    }
    try {
      const res = await feHelper.callApiActivateChargerByQR(params);
      if (res) {
        const { transaction, payment, qrData, expiryInSeconds, link } = res;
        if (res.result === 'success') {
          if (link) {
            window.location.href = link;
          } else {
            console.log({ qrData });
            dispatch(setData(res));
            router.navigate('/prepaid/qr/payment');
            setCreatingLink(false);
          }
        } else {
          ToastHelper.showError(res.result);
        }
      }
    } catch (error) {
      ToastHelper.showError(error.response.data.reason);
    }

    if (refContainer.current) {
      refContainer.current.release();
      refContainer.current.destroy();
    }
  };

  const buildSeparator = () => {
    return (
      <div
        className="my-4"
        style={{
          borderBottom: `1px solid ${AppColors.gray[300]}`,
        }}
      ></div>
    );
  };

  const handleSetSelectedModel = (value) => {
    const brand = vehicleBrandList?.find((brand) =>
      brand.models.some((model) => model.name === value)
    );

    const allModels = vehicleBrandList?.flatMap((brand) => brand.models);
    const model = allModels?.find((model) => model.name === value);

    if (brand && model) {
      setSelectedModel({
        brand: { brandId: brand.brandId, name: brand.name },
        model: {
          modelId: model.modelId,
          name: model.name,
          batteryCapacity: model.batteryCapacity,
          image: model.image,
        },
      });
    }
  };

  const handleCloseDropdown = () => {
    $('#toggle-brand').dropdown('toggle');
  };

  const handleCheckAmount = (amount) => {
    const invalidFeedback = document.getElementsByClassName('invalid-feedback')[0];
    if (invalidFeedback) {
      if (amount === undefined || amount === '') {
        setIsInvalid(true);
        invalidFeedback.innerText = t('amountRequired');
      } else if (amount < 1) {
        setIsInvalid(true);
        invalidFeedback.innerText = t('amountGreaterZero');
      } else {
        invalidFeedback.innerText = '';
      }
    }
  };

  const buildNoticeCard = (icon, title, description, titleColor, descriptionColor = AppColors.gray[800]) => {
    return (
      <div
        className="py-4 px-4 d-flex bg-white rounded-lg shadow-sm h-100"
        style={{
          border: `1px solid ${AppColors.gray[300]}`,
          minWidth: '320px',
          flex: '1 1 320px',
        }}
      >
        <img src={icon} width={55} height={55} className="me-3 flex-shrink-0" alt="" />
        <div className="d-flex flex-column">
          <div style={UIHelper.buildFontStyle('600', '16px', titleColor)}>
            {title}
          </div>
          <div style={UIHelper.buildFontStyle('400', '14px', descriptionColor)} className="mt-1">
            {description}
          </div>
        </div>
      </div>
    );
  };

  const noticesList = [
    {
      icon: AppResource.icons.tmt.icSpeaker,
      title: 'Lưu ý khi sạc không đăng nhập',
      description: 'Trường hợp sạc xe không đăng nhập tài khoản qua ứng dụng EVG Charger, tiền thừa sau khi dừng sạc sẽ không được hoàn lại.',
      titleColor: AppColors.danger,
    },
    {
      icon: AppResource.icons.tmt.icLight,
      title: 'Bạn muốn biết cần sạc bao nhiêu tiền? ',
      description: 'Nhập thông tin xe hệ thống sẽ tự động tính số tiền bạn cần sạc.',
      titleColor: AppColors.primary,
    },
  ]

  const getPaymentMethodsLogo = (paymentMethod) => {
    switch (paymentMethod) {
      case 'QR':
        return AppResource.icons.tmt.icLogoQR;
      case 'BANK':
        return AppResource.icons.tmt.icLogoBank;
      case 'VNPAY':
        return AppResource.icons.tmt.icLogoVNPay;
      case 'MOMO':
        return AppResource.icons.tmt.icLogoMomo;
    }
  }

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center pt-5"
      style={{
        backgroundImage: `url(${AppResource.images.tmt.bgAuthForm})`,
        backgroundSize: 'cover',
      }}
    >
      <div
        className="container px-0"
        style={{
          paddingBottom: `${65 + 16}px`,
        }}
      >
        {/* header */}
        <div className="d-flex flex-column align-items-center px-5 py-10">
          <div className="d-flex flex-column align-items-center">
            <img alt="logo" src={AppResource.icons.tmt.evgLogoAuth} className="w-175px" />
          </div>
        </div>

        <div
          ref={refCardInfo}
          className="p-5 bg-white mx-5"
          style={{
            border: `1px solid ${AppColors.gray[300]}`,
            borderRadius: '10px',
          }}
        >
          {(
            chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.available ||
            chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.preparing
          ) &&
            chargePointDetail?.connected === 1 ? (
            <span
              style={{
                fontWeight: '600',
                fontSize: Utils.convertToFontSize(18),
                color: AppColors.gray[800],
              }}
            >
              {t('chargeConnectorInfo')}
            </span>
          ) : (
            <div>
              <div className="d-flex justify-content-center mb-3">
                <img src={AppResource.images.tmt.connectorCharging} />
              </div>
              <div className="mt-3 mb-5 text-center">
                <div
                  className="font-weight-boldest"
                  style={{ fontSize: Utils.convertToFontSize(20), color: AppColors.danger }}
                >
                  {chargePointDetail?.connected === 0
                    ? 'Trụ sạc chưa được kết nối'
                    : 'Vòi sạc đang bận'}
                </div>
                <div
                  className="font-weight-bolder px-8"
                  style={{ color: AppColors.gray[600], fontSize: Utils.convertToFontSize(16) }}
                >
                  {chargePointDetail?.connected === 0
                    ? 'Vui lòng thực hiện kết nối trụ sạc và thực hiện lại'
                    : 'Vòi sạc này đang được sử dụng. Vui lòng chọn vòi khác.'}
                </div>
              </div>
            </div>
          )}

          {/* thong tin cong sac */}
          <div
            className="py-4 mt-2 px-4 d-flex flex-row justify-content-between"
            style={{
              border: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '5px',
            }}
          >
            <div className="d-flex flex-column">
              <span
                style={{
                  fontWeight: '500',
                  fontSize: Utils.convertToFontSize(16),
                  color: AppColors.gray[600],
                }}
              >
                Cổng sạc:{' '}
                <span style={UIHelper.buildFontStyle('500', '16px', AppColors.primary)}>{chargePointDetail?.type}</span>
              </span>
              <span style={UIHelper.buildFontStyle('700', '18px', AppColors.primary)}>
                {ChargeHelper.Utils.getChargeConnectorTypeName(chargeConnectorDetail?.type)}
              </span>
              <span
                style={{
                  fontWeight: '500',
                  fontSize: Utils.convertToFontSize(16),
                  color: AppColors.gray[600],
                }}
              >
                Công suất:{' '}
                <span style={{ color: AppColors.primary }}>
                  {chargePointDetail?.power
                    ? `${(chargePointDetail?.power / 1000).toFixed(2)} kW`
                    : 'N/A'}
                </span>
              </span>
            </div>

            <img
              className="h-75px"
              style={{ objectFit: 'contain', aspectRatio: '1/1' }}
              src={
                AppResource.images.chargeConnectorTypes[
                `${chargeConnectorDetail?.type?.toLowerCase()}Connector`
                ]
              }
            />
          </div>

          {/* thong bao voi sac dang ban */}
          {/* {chargeConnectorDetail?.status !== AppConstants.chargeConnectorStatus.available && (
            <div
              className="p-5 d-flex align-items-center mt-3"
              style={{
                backgroundColor: 'rgba(255, 246, 246, 1)',
                border: `1px dashed ${AppColors.danger}`,
              }}
            >
              <img className="w-45px h-45px" src={AppResource.icons.icConnectorBusy} />

              <div className="d-flex flex-column ml-4">
                <span
                  style={{
                    color: AppColors.danger,
                    fontWeight: '700',
                    fontSize: Utils.convertToFontSize(18),
                  }}
                >
                  Vòi sạc đang bận
                </span>
                <span
                  style={{
                    color: AppColors.gray[700],
                    fontWeight: '500',
                    fontSize: Utils.convertToFontSize(14),
                  }}
                >
                  Vòi sạc này đang được sử dụng. Vui lòng chọn vòi khác.
                </span>
              </div>
            </div>
          )} */}

          <div
            className="py-4 mt-3 d-flex flex-column"
            style={{
              border: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '5px',
            }}
          >
            {buildRowItem(
              t('chargePointStatus'),
              chargeConnectorDetail?.chargePoint?.status
                ? t(`chargePointStatus_${chargeConnectorDetail?.chargePoint?.status}`)
                : 'N/A',
              chargeConnectorDetail?.chargePoint?.status == AppConstants.chargePointStatus.available
                ? AppColors.primary
                : AppColors.danger
            )}
            {buildSeparator()}
            {buildRowItem(t('chargePointCode'), chargePointDetail?.pointCode)}
            {buildSeparator()}
            {flatChargeMode && buildRowItem(
              t('Đơn giá'),
              chargePricing?.flatPrice
                ? `${Utils.formatNumber(chargePricing?.flatPrice)} ${chargePricing?.currency ?? 'VNĐ'}`
                : 'N/A'
            )}
            {!flatChargeMode && (
              <>
                {buildRowItem(
                  t('Giá giờ bình thường'),
                  chargePricing?.normalPrice
                    ? `${Utils.formatNumber(chargePricing.normalPrice)} ${chargePricing?.currency ?? 'VNĐ'}/kWh`
                    : 'N/A'
                )}
                {buildSeparator()}
                {buildRowItem(
                  t('Giá giờ thấp điểm'),
                  chargePricing?.offPeakPrice
                    ? `${Utils.formatNumber(chargePricing.offPeakPrice)} ${chargePricing?.currency ?? 'VNĐ'}/kWh`
                    : 'N/A'
                )}
                {buildSeparator()}
                {buildRowItem(
                  t('Giá giờ cao điểm'),
                  chargePricing?.peakPrice
                    ? `${Utils.formatNumber(chargePricing.peakPrice)} ${chargePricing?.currency ?? 'VNĐ'}/kWh`
                    : 'N/A'
                )}
              </>
            )}
            {buildSeparator()}
            {buildRowItem(
              t('Chờ miễn phí'),
              chargePricing?.freeOverchargeDuration
                ? `${Utils.formatNumber((chargePricing?.freeOverchargeDuration / 60).toFixed(3))} phút`
                : 'N/A'
            )}
            {buildSeparator()}
            {buildRowItem(
              t('overtimeFee'),
              chargePricing?.overchargePrice
                ? `${Utils.formatNumber(chargePricing?.overchargePrice)} ${chargePricing?.currency ?? 'VNĐ'}/phút`
                : 'N/A'
            )}
            {buildSeparator()}
            {buildRowItem(
              t('Giá đặt giữ chỗ'),
              'N/A'
            )}
          </div>

          {chargeConnectorDetail?.status !== AppConstants.chargeConnectorStatus.available && (
            <div className="mt-4">
              <KTBSButton
                color={KTBSButtonColor.success}
                title={t('goHomepage')}
                buttonTitleFontSize={18}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={() => {
                  router.navigate('/');
                }}
                additionalClassName="w-100"
              />
            </div>
          )}
        </div>

        {(
          chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.available ||
          chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.preparing
        ) && chargePointDetail?.connected === 1 &&
          <div className="mx-5 mt-4">
            <KTScrollCard
              direction="horizontal"
              containerWidth="100%"
              containerHeight="140px"
              scrollButtonStyle={{
                backgroundColor: 'rgba(255,255,255,0.9)',
                backdropFilter: 'blur(8px)',
              }}
            >
              <div className="d-flex w-100 h-100 gap-3">
                {noticesList.map((notice, index) => (
                  <div
                    key={index}
                    className="h-100"
                    style={{
                      flex: '1 1 320px',
                      minWidth: '320px',
                      maxWidth: 'calc(50% - 6px)',
                    }}
                  >
                    {buildNoticeCard(
                      notice.icon,
                      notice.title,
                      notice.description,
                      notice.titleColor
                    )}
                  </div>
                ))}
              </div>
            </KTScrollCard>
          </div>
        }

        {/* thong tin xe */}
        {(
          chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.available ||
          chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.preparing
        ) &&
          chargePointDetail?.connected === 1 && (
            <div className="mt-4 mx-5" id="container-content">
              <div
                className="p-5 bg-white w-100"
                style={{
                  border: `1px solid ${AppColors.gray[300]}`,
                  borderRadius: '10px',
                }}
              >
                <span
                  style={{
                    fontWeight: '600',
                    fontSize: Utils.convertToFontSize(18),
                    color: AppColors.gray[800],
                  }}
                >
                  {t('Thông tin sạc')}
                </span>
                <Formik
                  initialValues={{
                    amount: 0,
                    plate: '',
                    batteryPercent: 0,
                    modelId: '',
                  }}
                  validationSchema={Yup.object({
                    amount: Yup.number().required(t('required')).min(1, t('invalid')),
                    plate: Yup.string()
                      .required(t('plateRequired'))
                      .test('len', t('invalid', { field: 'plate' }), (val) => {
                        if (val) {
                          return val.toString().trim();
                        }
                      }),
                    batteryPercent: Yup.number().min(0, t('invalid')).max(100, t('invalid')).nullable(),
                    modelId: Yup.string().nullable(),
                  })}
                  enableReinitialize={true}
                  onSubmit={(values) => {
                    console.log('values: ', values);
                  }}
                >
                  {(formikProps) => {
                    refFormik.current = formikProps;
                    return (
                      <div className="mt-0" style={{}}>
                        {/* chon dong xe */}
                        <KTFormGroup
                          label={
                            <span
                              className="font-weight-boldest"
                              style={{ fontSize: Utils.convertToFontSize(16) }}
                            >
                              {t('vehicleModel')}
                            </span>
                          }
                          inputName="modelId"
                          additionalClassName="mb-4"
                          inputElement={
                            <Field name="modelId">
                              {({ field, form, meta }) => {
                                return (
                                  <KTBSDropdown
                                    id="toggle-brand"
                                    toggleElement={
                                      <button
                                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between font-weight-bold"
                                        type="button"
                                        style={{ fontSize: Utils.convertToFontSize(16) }}
                                      >
                                        {selectedModel
                                          ? `${selectedModel.brand.name} ${selectedModel.model.name}`
                                          : t('chooseVehicleModel')}
                                      </button>
                                    }
                                    selectedValue={field.value}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{
                                      maxHeight: '30vh',
                                    }}
                                    autoCloseBehavior={KTBSDropdowAutoCloseBehavior.outside}
                                    contentEl={
                                      <div>
                                        <KTFormSearch
                                          name="search-bar"
                                          className="mx-3 my-1 search-form-border"
                                          placeholder={t('typeToSearch')}
                                          value={searchTerm}
                                          onSubmit={(value) => setSearchTerm(value)}
                                        />
                                        <KTFolderTreeView
                                          key={openedBrands.join(',')}
                                          children={filteredFolderTreeData}
                                          selectedValue={field.value}
                                          openedBrands={openedBrands}
                                          onSelect={(value) => {
                                            form.setFieldValue(field.name, value);
                                            handleSetSelectedModel(value);
                                            handleCloseDropdown();
                                          }}
                                          isVehicleBrandTree={true}
                                        />
                                      </div>
                                    }
                                  />
                                );
                              }}
                            </Field>
                          }
                        />
                        {selectedModel && (
                          <div
                            className="d-flex gap-3 p-2 mb-5"
                            style={{ backgroundColor: AppColors.gray[200], borderRadius: 5 }}
                          >
                            <div className="w-100px h-65px ">
                              <img
                                alt="model-image"
                                src={Utils.getFullUrl(selectedModel.model.image)}
                                style={{
                                  width: '100px',
                                  height: '65px',
                                  borderRadius: 5,
                                  objectFit: 'cover',
                                }}
                              />
                            </div>
                            <div className="font-weight-boldest">
                              <div style={{ color: AppColors.gray[600] }}>
                                {selectedModel.brand.name}
                              </div>
                              <div
                                style={{
                                  color: AppColors.gray[900],
                                  fontSize: Utils.convertToFontSize(22),
                                }}
                              >
                                {selectedModel.model.name}
                              </div>
                              <div style={{ color: AppColors.gray[600] }}>
                                {t('batteryCapacity')}:{' '}
                                {Utils.formatNumber(selectedModel.model.batteryCapacity)} kWh
                              </div>
                            </div>
                          </div>
                        )}

                        <KTFormGroup
                          label={
                            <span
                              className="font-weight-boldest"
                              style={{ fontSize: Utils.convertToFontSize(16) }}
                            >
                              {t('currentEnergy')} (%)
                            </span>
                          }
                          inputName="batteryPercent"
                          additionalClassName="mb-2"
                          inputElement={
                            <FastField name="batteryPercent">
                              {({ field, form, meta }) => {
                                return (
                                  <KTFormInput
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                      setCurrentBattery(value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid={true}
                                    type={KTFormInputType.number}
                                    placeholder={t('enterCurrentBatteryPercent')}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                    additionalInputClassName="font-size-input"
                                  />
                                );
                              }}
                            </FastField>
                          }
                        />
                        <p
                          className="font-weight-bold mb-4"
                          style={{
                            fontSize: Utils.convertToFontSize(14),
                            color: AppColors.gray[700],
                          }}
                        >
                          Nhập mức pin hiện tại để hệ thống gợi ý tương đối số tiền cần sạc.
                        </p>

                        {needAmount ? (
                          <div
                            className="p-5 mt-2 mb-3 font-weight-bolder"
                            style={{
                              backgroundColor: 'rgba(247, 255, 246, 1)',
                              border: `1px dashed ${AppColors.primary}`,
                              color: AppColors.gray[600],
                              fontSize: Utils.convertToFontSize(16),
                            }}
                          >
                            Với lượng{' '}
                            <span style={{ color: AppColors.primary }}>
                              pin hiện tại là {Utils.formatNumber(currentBattery)}%
                            </span>
                            , hệ thống gợi ý số tiền bạn cần để{' '}
                            <span style={{ color: AppColors.primary }}>
                              sạc tới 100% là {Utils.formatNumber(needAmount)} VNĐ
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}

                        {
                          showNote && (
                            <div
                              className="p-5 mt-2 mb-3 font-weight-bolder"
                              style={{
                                backgroundColor: 'rgba(247, 255, 246, 1)',
                                border: `1px dashed ${AppColors.primary}`,
                                color: AppColors.gray[600],
                                fontSize: Utils.convertToFontSize(16),
                                lineHeight: 2
                              }}>
                              <div>
                                • Ước lượng giá sạc giờ thấp điểm: {Utils.formatNumber(handleComputeNeedAmount(chargePricing?.offPeakPrice))} VNĐ
                              </div>
                              <div>
                                • Ước lượng giá sạc giờ bình thường: {Utils.formatNumber(handleComputeNeedAmount(chargePricing?.normalPrice))} VNĐ
                              </div>
                              <div>
                                • Ước lượng giá sạc giờ cao điểm: {Utils.formatNumber(handleComputeNeedAmount(chargePricing?.peakPrice))} VNĐ
                              </div>
                            </div>
                          )
                        }

                        <div className="position-relative mb-4 w-100">
                          <div className="mb-2">
                            <span
                              className="font-weight-boldest"
                              style={{ fontSize: Utils.convertToFontSize(16) }}
                            >
                              {t('inputMoneyAmount')}{' '}
                            </span>
                            <span style={{ color: AppColors.danger }}>(*)</span>
                          </div>
                          <KTFormGroup
                            inputName="amount"
                            additionalClassName={`mb-2 rounded ${isTouch
                              ? paymentAmount < 1
                                ? 'invalid-border'
                                : 'valid-border'
                              : isInvalid
                                ? 'invalid-border'
                                : needAmount
                                  ? needAmount > 0
                                    ? 'valid-border'
                                    : 'invalid-border'
                                  : ''
                              }`}
                            inputElement={
                              <Field name="amount">
                                {({ field, form, meta }) => {
                                  return (
                                    <div className='w-100'>
                                      <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        additionalInputClassName={`w-100 ${isTouch ? 'border-color-default ' : ''
                                          } ${isTouch
                                            ? paymentAmount < 1
                                              ? 'invalid-bg'
                                              : ''
                                            : isInvalid
                                              ? 'invalid-bg'
                                              : ''
                                          } border-bottom-0 rounded-bottom-0 rounded-top-left-0 font-size-input`}
                                        onChange={(value) => {
                                          handleCheckAmount(value);
                                          form.setFieldValue(field.name, value);
                                          setIsTouch(true);
                                          setPaymentAmount(value);
                                        }}
                                        onBlur={() => {
                                          form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={t('enterAmount')}
                                        enableInputGroup={true}
                                        prependElements={['VNĐ']}
                                        onClick={() => setIsTouch(true)}
                                        inputGroupAdditionalClassName="w-60px border-bottom-0 rounded-bottom-0 rounded-top-right-0 bg-grey-100 font-weight-bold"
                                      />
                                      <KTFormInput
                                        name="convert"
                                        value={Utils.formatNumber(
                                          formikProps.values.amount / currentPrice
                                        )}
                                        additionalInputClassName={`w-100 rounded-top-0 rounded-bottom-left-0 font-size-input ${isTouch
                                          ? formikProps.values.amount &&
                                            formikProps.values.amount < 1
                                            ? 'invalid-bg'
                                            : ''
                                          : isInvalid
                                            ? 'invalid-bg'
                                            : ''
                                          }`}
                                        type={KTFormInputType.text}
                                        enableInputGroup={true}
                                        prependElements={['kWh']}
                                        disabled={true}
                                        inputGroupAdditionalClassName="w-60px rounded-top-0 rounded-bottom-right-0 bg-grey-100 font-weight-bold"
                                      />
                                      <div className="position-absolute right-0 mr-4 top-0 mt-18">
                                        <span
                                          className="position-relative rounded-circle p-2 bg-white zindex-5"
                                          style={{ border: `1px solid #E4E6EF` }}
                                        >
                                          <i className="fa-regular fa-arrows-repeat rotate-90 w-15px h-15px" />
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }}
                              </Field>
                            }
                            isRequired={true}
                          />
                          <div className="invalid-feedback"></div>
                        </div>

                        <KTFormGroup
                          label={
                            <span
                              className="font-weight-boldest"
                              style={{ fontSize: Utils.convertToFontSize(16) }}
                            >
                              {t('plate')}
                            </span>
                          }
                          inputName="plate"
                          additionalClassName="mb-0"
                          inputElement={
                            <FastField name="plate">
                              {({ field, form, meta }) => {
                                return (
                                  <KTFormInput
                                    name={field.name}
                                    value={field.value}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    onBlur={() => {
                                      form.setFieldTouched(field.name, true);
                                    }}
                                    enableCheckValid
                                    type={KTFormInputType.text}
                                    placeholder={t('Nhập biển số xe')}
                                    isValid={_.isEmpty(meta.error)}
                                    isTouched={meta.touched}
                                    feedbackText={meta.error}
                                    additionalInputClassName="font-size-input"
                                  />
                                );
                              }}
                            </FastField>
                          }
                          isRequired={true}
                        />
                      </div>
                    );
                  }}
                </Formik>
              </div>

              <div
                className="p-5 bg-white mt-4"
                style={{
                  border: `1px solid ${AppColors.gray[300]}`,
                  borderRadius: '10px',
                }}
              >
                <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])} className="mb-3">
                  Phương thức thanh toán
                </div>
                <div className='d-flex flex-column gap-3'>
                  {paymentMethodsList?.map(item => (
                    <div
                      className='p-4 d-flex align-items-center gap-3 rounded-lg cursor-pointer'
                      style={{ border: fundingSource === item.fundingSource ? `2px solid ${AppColors.primary}` : `1px solid ${AppColors.gray[300]}` }}
                      onClick={() => setFundingSource(item.fundingSource)}
                    >
                      <img src={getPaymentMethodsLogo(item.fundingSource)} width={36} height={36} />
                      <div style={UIHelper.buildFontStyle('500', '16px', AppColors.gray[800])}>
                        {item.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
      </div>

      {(
        chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.available ||
        chargeConnectorDetail?.status === AppConstants.chargeConnectorStatus.preparing
      ) &&
        chargePointDetail?.connected === 1 && (
          <div className="position-fixed bottom-0 zindex-5 mt-5">
            <div
              className="mb-5"
              style={{
                width: `${refCardInfo.current?.offsetWidth}px`,
                border: '1px solid #28CE7F',
                boxShadow: '0px 7px 20px -3px #50FF9D40',
                borderRadius: 10,
              }}
            >
              <KTBSButton
                color={KTBSButtonColor.success}
                title={
                  <div>
                    {paymentAmount ? (
                      <>
                        {t('payment')}{' '}
                        <span style={{ color: AppColors.primaryLight }}>
                          • {Utils.formatNumber(paymentAmount)} {t('moneyUnit')}
                        </span>
                      </>
                    ) : (
                      t('payment')
                    )}
                  </div>
                }
                size={KTBSButtonSize.large}
                borderRadius={8}
                buttonTitleFontWeight="600"
                onPress={() => handleSubmit()}
                additionalClassName="w-100"
                buttonTitleFontSize={18}
              />
            </div>
          </div>
        )}
    </div>
  );
}

export default ChargePointDetailScreen;
